import React from 'react'

const Instagram = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className="w-full fill-current"
		viewBox="0 0 32 32"
	>
		<path
			d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm4.301 6.4h-8.603l-.218.004A5.305 5.305 0 0 0 6.4 11.7V20.3l.004.219a5.305 5.305 0 0 0 5.294 5.08h8.603l.218-.004A5.305 5.305 0 0 0 25.6 20.3V11.7l-.004-.219A5.305 5.305 0 0 0 20.3 6.4zm0 1.704a3.6 3.6 0 0 1 3.596 3.595V20.3l-.005.191a3.6 3.6 0 0 1-3.59 3.404h-8.604l-.19-.005a3.6 3.6 0 0 1-3.404-3.59V11.7l.005-.191a3.6 3.6 0 0 1 3.59-3.404zM16 11.053A4.953 4.953 0 0 0 11.053 16 4.953 4.953 0 0 0 16 20.947 4.953 4.953 0 0 0 20.947 16 4.953 4.953 0 0 0 16 11.053zm0 1.703A3.247 3.247 0 0 1 19.244 16 3.247 3.247 0 0 1 16 19.244 3.247 3.247 0 0 1 12.756 16 3.247 3.247 0 0 1 16 12.756zm5.155-3.148a1.254 1.254 0 0 0-1.25 1.25c0 .328.135.65.367.883.232.232.555.366.883.366.33 0 .65-.134.883-.366.233-.233.366-.555.366-.883 0-.33-.133-.652-.366-.884a1.255 1.255 0 0 0-.883-.366z"
			fillRule="evenodd"
		/>
	</svg>
)

export default Instagram
